export default class DtoLiftingEquipments {
    constructor(obj) {
        this.idStation = obj.idStation
        this.numberPumps = obj.numberPumps
        this.nominalFlow = obj.nominalFlow
        this.hmt = obj.hmt
        this.typeDetectionLevel = obj.typeDetectionLevel
    }
}